import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Work from './pages/Work';
import Nymair from './pages/Nymair';
import Nav from './components/nav';
import Yolanda from './pages/Yolanda';
import Makhia from './pages/Makhia';
import Trey from './pages/Trey';
import Miracle from './pages/Miracle';
import Nyla from './pages/Nyla';
import Dj from './pages/Dj';
import Wyniquekia from './pages/Wyniquekia';
import Marcine from './pages/Marcine';



function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Work" element={<Work />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Nymair" element={<Nymair />} />
        <Route path="/Yolanda" element={<Yolanda />} />
        <Route path="/Makhia" element={<Makhia />} />
        <Route path="/Trey" element={<Trey />} />
        <Route path="/Miracle" element={<Miracle />} />
        <Route path="/Nyla" element={<Nyla />} />
        <Route path="/Dj" element={<Dj />} />
        <Route path="/Wyniquekia" element={<Wyniquekia />} />
        <Route path="/Marcine" element={<Marcine />} />
      </Routes >
      {/* <YouTubePlaylist/> */}
    </>
  )
}

export default App;